/**
 * 작성자 : 홍선영
 * 날짜 : 2025.02.25
 * 기능 : 배열의 첫 번째 항목이 부모 컨테이너의 상단에 도달했을 때 true를 반환하는 hook
 */

import { useLayoutEffect, useState } from 'react';

const useFirstItemAtTop = (
  parentRef: React.RefObject<HTMLElement>,
  itemRef: React.RefObject<HTMLElement>,
  list: any[],
  tolerance: number = 5 // 허용 오차 (픽셀)
): boolean => {
  const [isAtTop, setIsAtTop] = useState(false);

  // ref.current 값을 추출 (이 값들이 변경되면 effect가 재실행됨)
  const parentCurrent = parentRef.current;
  const itemCurrent = itemRef.current;

  useLayoutEffect(() => {
    if (!parentCurrent || !itemCurrent || !list || list.length === 0) return () => {};

    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      const entry = entries[0];
      if (!entry) return;
      // entries.forEach((entry) => {
      const parentRect = parentCurrent!.getBoundingClientRect();
      const itemRect = itemCurrent!.getBoundingClientRect();
      // 첫번째 아이템이 부모의 상단과 거의 일치하면 true 설정
      if (entry.isIntersecting && Math.abs(itemRect.top - parentRect.top) <= tolerance) {
        setIsAtTop(true);
      } else {
        setIsAtTop(false);
      }
      // });
    };

    const observer = new IntersectionObserver(observerCallback, {
      root: parentCurrent,
      threshold: 0, // 최소한의 픽셀이라도 보이면 트리거
    });

    observer.observe(itemCurrent);

    return () => {
      observer.disconnect();
    };
  }, [parentCurrent, itemCurrent, tolerance, list]);

  return isAtTop;
};

export default useFirstItemAtTop;
